module.exports = __webpack_public_path__ + "img/xiangmu3.1381429d.png";